import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  fetchDeliveryStatistic,
  refreshDeliveryStatistic,
} from 'reduxStore/deliveryStatistic/asyncActions';
import { DeliveryStatisticState, STORE_NAME } from 'reduxStore/deliveryStatistic/initialState';
import { DeliveryStatisticModel } from 'api/dto/DeliveryStatistic.dto';
import { Resource } from 'model/Resource';
import { addAsyncCasesNew } from 'shared/utils/redux';

export const deliveryStatisticSlice = createSlice({
  name: STORE_NAME,
  initialState: DeliveryStatisticState.INITIAL_DOMAIN,
  reducers: {
    clearDeliveryStatistic: () => DeliveryStatisticState.INITIAL_DOMAIN,
    setDeliveryStatistic: (state, action: PayloadAction<DeliveryStatisticModel[]>) => {
      state.listResource = Resource.createResolvedResource({ data: action.payload });
    },
  },
  extraReducers: (builder) => {
    addAsyncCasesNew(builder, fetchDeliveryStatistic, (state, action) => {
      state.listResource = action.payload;
    });
    addAsyncCasesNew(builder, refreshDeliveryStatistic, () => {});
  },
});

export const { clearDeliveryStatistic, setDeliveryStatistic } = deliveryStatisticSlice.actions;
